import { Typography } from '@mui/material';
import type { InventoryResource } from '@repo/api-gw-sdk';

import { useDAL } from '@/contexts/useDAL';
import type { BackupVault } from '@/data/vaults/backupVault';
import { dayjs } from '@/utils/dayjs';

import { RestoreAzureVMWizard } from './restoreAzureVMWizard';

import { Loader } from '../layout/loading';

export const RestoreAzureVMPitrWizard = ({
  resource,
  restoreToTime,
  vault,
  onClose,
  onBack,
}: {
  resource: InventoryResource;
  restoreToTime?: Date;
  vault?: BackupVault;
  onClose: () => void;
  onBack: () => void;
}) => {
  const dal = useDAL();
  const snapshotTime = restoreToTime ?? dayjs.utc().endOf('hour').toDate();
  const start = dayjs.utc(snapshotTime).subtract(1, 'day').toDate();
  const end = snapshotTime;
  const { data: snapshots, isLoading } = dal.inventory.snapshots.useList(
    resource.id,
    0,
    100,
    start,
    end
  );

  if (isLoading) {
    return <Loader />;
  }

  const latestSnapshot = snapshots?.data?.filter(
    (snap) => snap.vaultId === vault?.id
  )?.[0];
  if (!latestSnapshot) {
    return (
      <Typography color='error'>
        No snapshot found for the given restore to time
      </Typography>
    );
  }

  return (
    <RestoreAzureVMWizard
      resource={resource}
      snapshot={latestSnapshot}
      restoreToTime={restoreToTime}
      vault={vault}
      isPiTR={true}
      onClose={onClose}
      onBack={onBack}
    />
  );
};
